export const sandboxMercadopago = true

export const configDev = {
  access_token: 'TEST-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'
}

export const configProd = {
  access_token: 'APP_USR-YYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYYY'
}

export const configMercadopago = sandboxMercadopago ? configDev : configProd

export const urlPayment = {
  preference_url: 'https://api.mercadopago.com/checkout/preferences',
  return_url: 'https://my-url-project.cloudfunctions.net/payment'
}
